import {
  action,
  observable,
  makeObservable,
  runInAction,
} from "mobx";
import api from "../../../api";
import { DatePickerProps, Modal, message } from "antd";
import CommonStore from "../common_store";
import dayjs from "dayjs";

class RecordingManageStore {
  @observable messageTemplate: boolean = false;
  @observable operateStatus: string = "";
  @observable videoUrl: string = "";
  //搜索表单字段
  @observable searchForm: any = {};
  @observable tableData: any = {};
  //表格加载状态
  @observable tableLoad: boolean = true;
  //分页信息
  @observable pageData: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.pageData.page = page;
        this.pageData.size = size;
        this.pageData = { ...this.pageData };
      });
      this.getRecordingPage();
    },
  };
  //视频文件
  @observable formData: any = null;
  //点击编辑框传值
  @observable lookPower: any = {};
  //编辑框控制字段
  @observable addOrUpdateModal: any = {
    title: "",
    configuration: false,
    updateModalType: (type: "configuration") => {},
    get isOpen(): boolean {
      return this.configuration;
    },
    open: (type: "configuration" , record: any) => {
      if (type === "configuration") {
        runInAction(() => {
          this.addOrUpdateModal.title = "录音设置";
          api.recordingManageApi.getrecordingConfig().then((res:any)=>{
            this.lookPower=res.data
            this.addOrUpdateModal.configuration = true;
          })
        });
      }
    },
    close: () => {
      runInAction(() => {
        this.addOrUpdateModal.configuration = false;
        this.lookPower = {};
      });
    },
  };
  commonStore: CommonStore;
  constructor(baseStore: CommonStore) {
    this.commonStore = baseStore;
    makeObservable(this);
  }

  setSearchForm(obj: any) {
    runInAction(() => {
      this.searchForm = obj;
    });
  }

  //重置分页
  resetPage() {
    runInAction(() => {
      this.pageData.page = 1;
    });
  }

  @action
  getRecordingPage() {
    this.commonStore.getPagePermission("call_recording_management");
    if (this.searchForm.time && this.searchForm.time.length > 0) {
      this.searchForm.endTime = dayjs(this.searchForm.time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
      );
      this.searchForm.startTime = dayjs(this.searchForm.time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
      );
    }
    runInAction(() => {
      this.tableData = {};
      this.tableLoad = true;
    });
    const data = { ...this.searchForm };
    data.size = this.pageData.size;
    data.page = this.pageData.page;
    api.recordingManageApi
      .getRecordingPage(data)
      .then((res: any) => {
        if (res.code == 200) {
          runInAction(() => {
            this.tableData = res.data;
            this.tableData = { ...this.tableData };
            this.tableLoad = false;
          });
        }
      })
      .catch((e: any) => {
        runInAction(() => {
          this.tableLoad = false;
        });
      });
  }

  setLookPower(obj: any) {
    runInAction(() => {
      this.lookPower = obj;
    });
  }

  @action
  updateRecording() {
    api.recordingManageApi
        .setrecordingConfig(this.lookPower)
        .then(async (res: any) => {
          this.getRecordingPage();
          message.success("设置成功");
          this.addOrUpdateModal.close();
        })
        .catch((err: any) => {});
  }
  confirmDownload(objectNames: string) {
    return new Promise((resolve, reject) => {
      Modal.confirm({
        centered: true,
        title: "确认下载",
        content: "您确定要下载通话录音吗？",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.downloadRecording(objectNames);
          return resolve(true);
        },
        onCancel: () => {
          return false;
        },
      });
    });
  }

  @action
  downloadRecording(objectNames: string) {
    console.log(objectNames)
    api.recordingManageApi
      .getDownloadUrl({objectNames:objectNames})
      .then(async (res: any) => {
        runInAction(() => {
          this.videoUrl = res.data;
        });
        this.download(this.videoUrl, "recording" + Date.now());
      })
      .catch((err: any) => {});
  }
  // 下载视频函数
  download(url: string, name: any) {
    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const a = document.createElement("a");
        const objectUrl = window.URL.createObjectURL(blob);
        a.download = name;
        a.href = objectUrl;
        a.click();
        window.URL.revokeObjectURL(objectUrl);
        a.remove();
      });
  }
}

export default RecordingManageStore;
